const TOGGLE_ICON_TRANSITION_MS = 150;
const PROGRESS_HOVER_TRANSITION_MS = 150;
const containerCls = "_rscq0m2pa";
const toggleCls = "_rst1cylr9e";
const toggleIconCls = "_rst7n9f99";
const toggleThrobberCls = "_rstn9ju8b";
const progressbarCls = "_rsp1qkab21";
const progressLineCls = "_rspzup1xa";
const progressHoverTransitionCls = "_rsp1y6v6c9";
const progressHoverLabelCls = "_rspx0jomc";
const timestampCls = "_rst9wu2kn";
const timestampSeparatorCls = "_rst15jgouu";
const closeButtonCls = "_rsc1xvy0k5";

export { PROGRESS_HOVER_TRANSITION_MS, TOGGLE_ICON_TRANSITION_MS, closeButtonCls, containerCls, progressHoverLabelCls, progressHoverTransitionCls, progressLineCls, progressbarCls, timestampCls, timestampSeparatorCls, toggleCls, toggleIconCls, toggleThrobberCls };
import "./molecule.audio-player.styles.linaria.module.css";
//# sourceMappingURL=molecule.audio-player.styles.js.map
